import { useEffect } from 'react';
import { useSocketStore } from '../../stores/useSocketStore';
import { useMapStore } from '../../stores/map/useMapStore';
import { useLoadingStore } from '../../stores/useLoadingStore';
import { useToast } from '../toast/useToast';

export function useMapSocket() {
    
    const socket = useSocketStore(state => state.socket);
    const codigoMap = useMapStore(state => state.codigoMap);
    const tripData = useMapStore(state => state.tripData);
    const { warning } = useToast();

    useEffect(() => {

        if (!socket) return;

        const {
            setRoute,
            setTrajeto,
            appendPositionRange,
            setLastPosition
        } = useMapStore.getState();

        const handleRoute = data => {
            setRoute(data);
        };

        const handleTrajeto = data => {
            setTrajeto(data);
        };

        const handleLastPosition = position => {

            setLastPosition(position);
            appendPositionRange(position);

        };

        socket.on('route:updated', handleRoute);
        socket.on('trajeto:updated', handleTrajeto);
        socket.on('positions:last:updated', handleLastPosition);

        return () => {

            socket.off('route:updated', handleRoute);
            socket.off('trajeto:updated', handleTrajeto);
            socket.off('positions:last:updated', handleLastPosition);

        };

    }, [socket]);

    useEffect(() => {

        if (!socket || !codigoMap) return;

        const joinMap = () => {

            const {
                setRoute,
                setTrajeto,
                setPositionsRange,
                clearPositionsRange,
                setLastPosition,
                clearLastPosition,
                setLoadingMap
            } = useMapStore.getState();

            const {
                setLoadingBackdrop,
                setLoadingTxt,
                stopLoading
            } = useLoadingStore.getState();

            // Enquanto ainda aguardamos a Home responder
            setLoadingBackdrop(true);

            setLoadingTxt('Carregando dados do mapa..');

            setLoadingMap(true);
            socket.emit(
                'map:join',
                {
                    codigo: codigoMap,
                    tripData
                },
                response => {

                    if(!response?.data?.route){
                        warning('Linha sem descrição.');
                    }

                    if(!response?.data?.trajeto){
                        warning('Linha sem trajeto previsto.');
                    }

                    clearPositionsRange();
                    clearLastPosition();

                    setRoute(response?.data?.route);
                    setTrajeto(response?.data?.trajeto);
                    setPositionsRange(
                        response?.data?.positionsRange || []
                    );
                    setLastPosition(
                        response?.data?.lastPosition || null
                    );

                    setLoadingMap(false);
                    stopLoading();

                }
            );

        };

        const handleConnect = () => {
            joinMap();
        };

        socket.on('connect', handleConnect);

        if (socket.connected) {
            joinMap();
        }

        return () => {

            socket.off('connect', handleConnect);

            if (socket.connected) {
                socket.emit('map:leave', {
                    codigo: codigoMap,
                    placa: tripData?.placa
                });
            }

        };

    }, [socket, codigoMap, tripData, warning]);

}